// extracted by css-extract-rspack-plugin
export default {"cls1":"PapersSearch-cls1_Zfc","cls2":"PapersSearch-cls2_m0p PapersSearch-cls1_Zfc"};